import { useRouter } from 'next/router';
import { AVAILABLE_LOCALES, LOCALES } from 'localization/constants/configEnums';

export const useCountryCodeTitle = ({
  mainTitle,
  defaultTitle,
}: {
  mainTitle?: string;
  defaultTitle?: string;
}) => {
  const { locale } = useRouter();
  let baseDisplayName = `${mainTitle || defaultTitle}`;

  if (!baseDisplayName.endsWith('GOAT')) {
    baseDisplayName = `${baseDisplayName} | GOAT`;
  }

  if (locale !== LOCALES.enUS && AVAILABLE_LOCALES[locale]) {
    return `${baseDisplayName} ${String(AVAILABLE_LOCALES[locale].country)}`;
  }
  return baseDisplayName;
};
